import { Injectable } from '@angular/core';
import moment from 'moment-timezone';

import { UserService } from 'app/user/user.service';

interface ModeCriteria {
  minDays?: number;
  maxDays?: number;
}

export enum ExpirationModes {
  expired = 'expired',
  expiring = 'expiring',
  valid = 'valid',
}

@Injectable()
export class DateExpirationService {
  constructor(private readonly userService: UserService) {}
  private lessThanOneDay: ModeCriteria = { maxDays: 0 };
  private betweenOneAndSevenDays: ModeCriteria = { minDays: 1, maxDays: 7 };
  private moreThanSevenDays: ModeCriteria = { minDays: 8 };

  private modeCriteria: { [key in ExpirationModes]: ModeCriteria } = {
    expired: this.lessThanOneDay,
    expiring: this.betweenOneAndSevenDays,
    valid: this.moreThanSevenDays,
  };

  getExpirationMode(date: string | number | Date): ExpirationModes {
    const [foundMode] = Object.entries(this.modeCriteria).find(([_, criteria]) =>
      this.isDateInMode(date, criteria),
    ) as [ExpirationModes, ModeCriteria];

    return foundMode;
  }

  private isDateInMode(date: string | number | Date, criteria: ModeCriteria): boolean {
    const compareMeasure = 'day';
    const sourceDate = (moment(Date.now()) as any).tz(this.timezone()).startOf(compareMeasure);
    const targetDate = (moment(date) as any).tz(this.timezone()).startOf(compareMeasure);
    const difference = targetDate.diff(sourceDate, compareMeasure);

    return (
      (criteria.minDays === undefined || difference >= criteria.minDays) &&
      (criteria.maxDays === undefined || difference <= criteria.maxDays)
    );
  }

  timezone(): string {
    return this.userService.getTimezone();
  }
}
